import React from "react";
import { Markdown } from "react-showdown";
import styled from "styled-components";

const StyledMde = styled(Markdown)`
  background-color: white;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  .editor-preview-full {
    height: unset;
    position: relative;
  }

  pre {
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    overflow: auto;
  }

  code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 4px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }
`;

type Props = {
  value: any;
};

const ReadOnlyEditor = (props: Props) => {
  return (
    <StyledMde markdown={props.value} options={{ tables: true, emoji: true }} />
  );
};

export default ReadOnlyEditor;

//headmap ist beispiel für die Bilder 400 /600 px
